import { render } from "./DesignWorksheetMath.vue?vue&type=template&id=7ef46b16&scoped=true"
import script from "./DesignWorksheetMath.vue?vue&type=script&lang=js"
export * from "./DesignWorksheetMath.vue?vue&type=script&lang=js"

import "./DesignWorksheetMath.vue?vue&type=style&index=0&id=7ef46b16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef46b16"]])

export default __exports__